<template>
  <div
    class="modal-container tw-flex tw-flex-col tw-p-[22px] tw-gap-[16px] tw-bg-[#FCFCFD] tw-rounded-[6px]"
  >
    <p
      class="tw-text-[#211F58] tw-text-[15px] tw-leading-[normal] tw-font-[600]"
    >
      {{ getComponentUiText("app-common-filter-modal-title-1") }}
    </p>

    <!-- List filter selected -->
    <div
      v-if="listFilterShow?.length || (searchValue && isSearch)"
      class="tw-gap-[10px] tw-flex tw-justify-between"
    >
      <div class="tw-gap-[10px] tw-flex selected-box tw-flex-1">
        <p
          v-for="item in listFilterShow"
          :key="item.targetId"
          class="selected-text tw-leading-[130%] tw-font-[500] tw-text-[11px] tw-text-[#387DFF]"
        >
          <span v-if="item.targetId === 'checklistItemCostId'"
            >{{
              getComponentUiText(
                "app-component-assessment-display-options-filter-importance-option-cost-1",
              )
            }}:
          </span>
          <span v-if="item.targetId === 'checklistItemEffortId'"
            >{{
              getComponentUiText(
                "app-component-assessment-display-options-filter-importance-option-effort-1",
              )
            }}:
          </span>
          <span v-if="item.targetId === 'checklistItemImpactId'"
            >{{
              getComponentUiText(
                "app-component-assessment-display-options-filter-importance-option-impact-1",
              )
            }}:
          </span>
          <span v-if="item.targetId === 'checklistItemImportanceId'"
            >{{
              getComponentUiText(
                "app-component-assessment-display-options-filter-importance-1",
              )
            }}:
          </span>
          {{
            !item.value.isHardText
              ? getComponentUiText(item.value.text)
              : item.value.text
          }}
          <span
            class="tw-cursor-pointer tw-w-[14px] tw-h-[14px] tw-bg-[white] tw-rounded-[13.455px] tw-items-center tw-justify-center tw-flex"
            @click="() => updateItemFilter(item)"
          >
            <closeIcon
              :h="6"
              :x1="5.33398"
              :y1="0"
              :w1="0.942758"
              :h1="7.54206"
              :x2="0.00195312"
              :y2="0.666992"
              :w2="0.942758"
              :h2="7.54206"
              :size="6"
              :color="'#DBDBDB'"
            />
          </span>
        </p>
        <p
          v-if="searchValue && isSearch"
          class="selected-text tw-leading-[130%] tw-font-[500] tw-text-[11px] tw-text-[#387DFF]"
        >
          {{ `"${searchValue}"` }}
          <span
            class="tw-w-[14px] tw-h-[14px] tw-bg-[white] tw-rounded-[13.455px] tw-items-center tw-justify-center tw-flex"
          >
            <closeIcon
              :h="6"
              :x1="5.33398"
              :y1="0"
              :w1="0.942758"
              :h1="7.54206"
              :x2="0.00195312"
              :y2="0.666992"
              :w2="0.942758"
              :h2="7.54206"
              :size="6"
              :color="'#DBDBDB'"
              @click="
                () => {
                  searchValue = '';
                }
              "
            />
          </span>
        </p>
      </div>
      <p
        class="tw-text-[#387DFF] tw-cursor-pointer tw-text-[11px] tw-font-[500] tw-leading-[14.3px] tw-mt-[3px]"
        @click="() => clearAll()"
      >
        {{
          `${getComponentUiText("app-common-filter-modal-clear-all-link-1")} (${
            listFilterShow.length + (searchValue && isSearch ? 1 : 0)
          })`
        }}
      </p>
    </div>

    <!-- Input search -->
    <div
      v-if="isSearch"
      class="tw-bg-[#fff] tw-items-center tw-pl-[15px] tw-py-[6px] tw-pr-[6px] tw-flex tw-justify-center tw-rounded-[6px] tw-border-solid tw-border-[1px] tw-border-[#EFF0F1] tw-h-[46px]"
    >
      <img src="/img/search_black_icon.svg" alt="search_icon" />
      <input
        v-model="inputValue"
        type="text"
        :placeholder="getComponentUiText('app-table-search-prompt-text-1')"
        class="tw-placeholder-[#B7B7B7] tw-border-none tw-ml-[11px] tw-w-full tw-text-[#211F58] tw-text-[13px] tw-font-[500]"
        @input="(val: any) => (inputValue = val.target?.value)"
      />
      <button
        v-if="inputValue"
        type="button"
        class="tw-bg-transparent tw-border-none tw-outline-none"
        @click="
          () => {
            inputValue = '';
          }
        "
      >
        <CloseBoxIcon :size="14" color="#DBDBDB" />
      </button>
      <span
        v-if="inputValue"
        class="tw-cursor-pointer tw-ml-[17px] tw-tracking-[1px] tw-text-[#387DFF] tw-text-[10px] tw-leading-[100%] tw-font-[700] tw-p-[11px] tw-flex tw-items-center tw-border-[1px] tw-border-solid tw-border-[#EFF0F1] tw-rounded-[6px]"
        @click="
          () => {
            searchValue = inputValue;
            applyFilter();
          }
        "
      >
        {{ getComponentUiText("app-common-filter-modal-search-button-1") }}
      </span>
    </div>
    <div
      class="tw-bg-[#fff] tw-border-[#EFF0F1] tw-border-[1px] tw-border-solid tw-flex tw-rounded-[6px] tw-flex-col tw-max-h-[315px] tw-overflow-auto"
    >
      <!-- Target section -->
      <div
        v-for="(target, index) in targetsFilter"
        :key="target.targetId"
        :class="` tw-flex tw-flex-col tw-px-[15px] ${
          index !== targetsFilter.length - 1 || isDate
            ? 'border-bottom-box'
            : ''
        } ${
          target.targetId === 'isMaster' ? 'tw-gap-[10px]' : 'tw-gap-[15px]'
        }`"
      >
        <div :class="`tw-flex tw-justify-between tw-items-center`">
          <p
            :class="`${
              target.values[0].type === 'input' && target.isOpen
                ? 'tw-pt-[12px]'
                : 'tw-py-[12px]'
            } tw-text-[13px] tw-font-[500] ${
              calNumberTarget(target.targetId)
                ? 'tw-text-[#211F58]'
                : 'tw-text-[#878787]'
            }`"
          >
            {{
              `${getComponentUiText(target.targetText)}${
                calNumberTarget(target.targetId)
                  ? " (" + calNumberTarget(target.targetId) + ")"
                  : ""
              }`
            }}
          </p>
          <div class="tw-flex tw-gap-[5px] tw-items-center tw-justify-center">
            <div
              v-if="target.targetId === 'checklistItemImportanceId'"
              class="tw-flex tw-items-center tw-w-[14px] tw-h-[14px]"
            >
              <Importance :class="['info-icon', 'tw-text-[#904BD6]']" />
            </div>
            <div
              v-if="target.targetId === 'checklistItemImpactId'"
              class="tw-flex tw-items-center tw-w-[14px] tw-h-[14px]"
            >
              <Impact :class="['info-icon', 'tw-text-[#904BD6]']" />
            </div>
            <div
              v-if="target.targetId === 'checklistItemEffortId'"
              class="tw-flex tw-items-center tw-w-[14px] tw-h-[14px]"
            >
              <Effort :class="['info-icon', 'tw-text-[#904BD6]']" />
            </div>
            <div
              v-if="target.targetId === 'checklistItemCostId'"
              class="tw-flex tw-items-center tw-w-[14px] tw-h-[14px]"
            >
              <Cost :class="['info-icon', 'tw-text-[#904BD6]']" />
            </div>
            <span
              :class="`tw-items-center tw-flex tw-cursor-pointer tw-z-[1] tw-p-[12px] arrowIcon ${
                target.isOpen ? 'rotated tw-pl-0 ' : 'tw-pr-0 '
              }`"
              @click="
                () => {
                  target.isOpen = !target.isOpen;
                  targetsFilter[index] = target;
                }
              "
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="7"
                viewBox="0 0 10 7"
                fill="none"
              >
                <path
                  d="M0.104884 2.00642L4.67976 7.19266C4.72096 7.23621 4.77061 7.2709 4.82567 7.2946C4.88073 7.31831 4.94005 7.33054 5 7.33054C5.05995 7.33054 5.11927 7.31831 5.17433 7.2946C5.22939 7.2709 5.27904 7.23621 5.32024 7.19266L9.89512 2.00642C9.93169 1.96522 9.95972 1.91717 9.97757 1.86505C9.99541 1.81293 10.0027 1.75778 9.99909 1.70281C9.99458 1.6474 9.97901 1.59345 9.95329 1.54417C9.92758 1.49488 9.89224 1.45124 9.84937 1.41584L9.07996 0.771202C9.03793 0.734847 8.98904 0.707283 8.93618 0.690139C8.88332 0.672995 8.82756 0.666619 8.77219 0.671387C8.71709 0.675373 8.66333 0.690299 8.61406 0.715292C8.56479 0.740285 8.52099 0.774843 8.48522 0.816951L5.0707 4.74718C5.04968 4.76801 5.02128 4.77969 4.99168 4.77969C4.96209 4.77969 4.93369 4.76801 4.91266 4.74718L1.51478 0.816951C1.44755 0.736646 1.35249 0.684663 1.2486 0.671387C1.19352 0.666053 1.13793 0.671766 1.08508 0.688192C1.03223 0.704618 0.983193 0.731424 0.940838 0.767043L0.150633 1.41584C0.107763 1.45124 0.0724248 1.49487 0.0467083 1.54417C0.0209918 1.59345 0.0054186 1.6474 0.000909419 1.70281C-0.00273159 1.75778 0.00458484 1.81293 0.0224338 1.86505C0.0402828 1.91717 0.0683087 1.96522 0.104884 2.00642Z"
                  fill="#387DFF"
                />
              </svg>
            </span>
          </div>
        </div>

        <!-- Target option -->
        <div v-if="target.isOpen" class="tw-gap-[15px]">
          <div
            v-if="target.targetId === 'isMaster' && target.isOpen"
            class="create-new-ass-modal-note"
          >
            <span>{{
              getComponentUiText(
                "app-component-assessment-display-options-filter-show-master-items-note-1",
              )
            }}</span>
          </div>
          <div
            v-for="(val, idx) in target.values"
            :key="val.id"
            :class="`tw-flex tw-items-center ${
              idx === target.values.length - 1
                ? target.isRadio
                  ? 'tw-mb-[26px]'
                  : 'tw-mb-[15px]'
                : val.type === 'input'
                  ? 'tw-mb-[15px]'
                  : 'tw-mb-[10px]'
            } tw-justify-between`"
          >
            <div
              v-if="val.type === 'input'"
              :class="'tw-flex tw-gap-[15px] tw-mr-[15px]'"
            >
              <CustomCheckBox
                :class="`!tw-mb-0 !tw-h-[20px] !tw-pl-0 tw-ml-[0px] tw-mr-[20px]`"
                size="20px"
                :is-checked="
                  filterSelecteds.filter(
                    (item) =>
                      item.targetId === target.targetId &&
                      item.value.id === val.id,
                  ).length > 0
                "
                :is-force-select="target.isRadio"
                @update:is-checked="updateItemFilter(val, target.targetId)"
              />
              <p
                class="tw-cursor-pointer tw-text-[13px] tw-font-[500] tw-leading-normal tw-text-[#231F20]"
                @click="updateItemFilter(val, target.targetId)"
              >
                {{ !val.isHardText ? getComponentUiText(val.text) : val.text }}
                <span
                  v-if="val.isDefault"
                  class="tw-text-[#b7b7b7] tw-text-[12px] tw-font-[400] tw-ml-[5px]"
                  >({{
                    getComponentUiText(
                      "app-component-filter-modal-default-tag-1",
                    )
                  }})</span
                >
              </p>
            </div>
            <div v-else :class="'tw-flex tw-gap-5'">
              <CustomCheckBox
                :class="`!tw-mb-0 !tw-h-[20px] !tw-pl-0 tw-ml-[0px] tw-mr-[20px]`"
                size="20px"
                :is-checked="
                  filterSelecteds.filter(
                    (item) =>
                      item.targetId === target.targetId &&
                      item.value.id === val.id,
                  ).length > 0
                "
                :is-force-select="target.isRadio"
                @update:is-checked="updateItemFilter(val, target.targetId)"
              />
              <p
                class="tw-cursor-pointer tw-text-[13px] tw-font-[500] tw-leading-normal tw-text-[#231F20]"
                @click="updateItemFilter(val, target.targetId)"
              >
                {{ !val.isHardText ? getComponentUiText(val.text) : val.text }}
                <span
                  v-if="val.isDefault"
                  class="tw-text-[#b7b7b7] tw-text-[12px] tw-font-[400] tw-ml-[5px]"
                  >({{
                    getComponentUiText(
                      "app-component-filter-modal-default-tag-1",
                    )
                  }})</span
                >
              </p>
            </div>
            <InputFilterModal
              v-if="val.type === 'input'"
              :id-percent-input="`PercentInput-${target.targetId}-${val.id}`"
              :value="
                filterSelecteds.find(
                  (item) =>
                    item.targetId === target.targetId &&
                    item.value.id === val.id,
                )?.value?.percent ?? ''
              "
              :is-show-button-clear="true"
              :is-in-range100="!!val.hindText"
              :hint-text="val.hindText ?? ''"
              :class-text="`!tw-font-[400] !tw-text-left placeholder:!tw-text-left`"
              :fixed="val.hindText ? 0 : 1"
              :disabled="false"
              @update:model-value="
                (percent) => onUpdateInput(percent, target, val)
              "
              @focus="(percent) => onFocusValue(percent, target, val)"
            />
          </div>
          <p
            v-if="
              (!target.isRadio ||
                (target.isRadio &&
                  target.targetId === 'checklistItemCategoryId')) &&
              filterSelecteds.filter(
                (item) => item.targetId === target.targetId,
              ).length > 0
            "
            class="tw-text-[#387DFF] !tw-mb-[26px] tw-text-[13px] tw-font-[400] tw-leading-[145%] tw-underline tw-decoration-solid clear-text-link tw-cursor-pointer"
            @click="
              () => {
                filterSelecteds = filterSelecteds.filter(
                  (item) => item.targetId !== target.targetId,
                );
              }
            "
          >
            {{ getComponentUiText("app-common-filter-modal-clear-link-1") }}
          </p>
        </div>
      </div>

      <!-- Select date section -->

      <div v-if="isDate" class="tw-flex tw-p-[15px] tw-pt-[12px] tw-flex-col">
        <div class="tw-flex tw-justify-between tw-items-center">
          <p
            :class="` tw-text-[13px] tw-font-[500] ${
              from || to ? 'tw-text-[#211F58]' : 'tw-text-[#878787]'
            }`"
          >
            {{
              getComponentUiText("app-common-filter-modal-select-date-target-1")
            }}
          </p>
          <span
            :class="`tw-items-center tw-flex tw-cursor-pointer tw-z-[1] arrowIcon ${
              selectedDateOpen ? 'rotated tw-pr-[10px]' : ''
            }`"
            @click="() => (selectedDateOpen = !selectedDateOpen)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="10"
              height="7"
              viewBox="0 0 10 7"
              fill="none"
            >
              <path
                d="M0.104884 2.00642L4.67976 7.19266C4.72096 7.23621 4.77061 7.2709 4.82567 7.2946C4.88073 7.31831 4.94005 7.33054 5 7.33054C5.05995 7.33054 5.11927 7.31831 5.17433 7.2946C5.22939 7.2709 5.27904 7.23621 5.32024 7.19266L9.89512 2.00642C9.93169 1.96522 9.95972 1.91717 9.97757 1.86505C9.99541 1.81293 10.0027 1.75778 9.99909 1.70281C9.99458 1.6474 9.97901 1.59345 9.95329 1.54417C9.92758 1.49488 9.89224 1.45124 9.84937 1.41584L9.07996 0.771202C9.03793 0.734847 8.98904 0.707283 8.93618 0.690139C8.88332 0.672995 8.82756 0.666619 8.77219 0.671387C8.71709 0.675373 8.66333 0.690299 8.61406 0.715292C8.56479 0.740285 8.52099 0.774843 8.48522 0.816951L5.0707 4.74718C5.04968 4.76801 5.02128 4.77969 4.99168 4.77969C4.96209 4.77969 4.93369 4.76801 4.91266 4.74718L1.51478 0.816951C1.44755 0.736646 1.35249 0.684663 1.2486 0.671387C1.19352 0.666053 1.13793 0.671766 1.08508 0.688192C1.03223 0.704618 0.983193 0.731424 0.940838 0.767043L0.150633 1.41584C0.107763 1.45124 0.0724248 1.49487 0.0467083 1.54417C0.0209918 1.59345 0.0054186 1.6474 0.000909419 1.70281C-0.00273159 1.75778 0.00458484 1.81293 0.0224338 1.86505C0.0402828 1.91717 0.0683087 1.96522 0.104884 2.00642Z"
                fill="#387DFF"
              />
            </svg>
          </span>
        </div>
        <div
          v-if="selectedDateOpen"
          class="tw-flex tw-gap-[15px] tw-mt-[15px] tw-mb-[10px]"
        >
          <p class="tw-flex-1 tw-text-[#B7B7B7] tw-text-[13px] tw-font-[400]">
            {{
              getComponentUiText(
                "app-common-filter-modal-select-date-target-from-1",
              )
            }}
          </p>
          <p class="tw-flex-1 tw-text-[#B7B7B7] tw-text-[13px] tw-font-[400]">
            {{
              getComponentUiText(
                "app-common-filter-modal-select-date-target-to-1",
              )
            }}
          </p>
        </div>
        <div v-if="selectedDateOpen" class="tw-flex tw-gap-[15px]">
          <div class="tw-flex-1">
            <DatePickInput
              v-model="from"
              class-name="!tw-h-[44px] !tw-px-[12px]"
              class-name-icon="icon-class"
              ref-picker="refPickers"
              :is-auto-focus="false"
            />
          </div>
          <div class="tw-flex-1 to-class">
            <DatePickInput
              v-model="to"
              :is-auto-focus="false"
              class-name="!tw-h-[44px] !tw-px-[12px]"
              class-name-icon="icon-class"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="tw-flex tw-justify-end">
      <b-button
        pill
        variant="primary"
        data-cy="add-domain-modal-button"
        class="button-add-domain tw-bg-[#387DFF] tw-h-[37px] !tw-text-[13px] !tw-font-[500] !tw-leading-[100%] tw-font-Poppins"
        type="submit"
        @click="
          () => {
            applyFilter();
          }
        "
      >
        {{
          getComponentUiText("app-common-filter-modal-apply-filter-button-1")
        }}
      </b-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import closeIcon from "@/components/svgs/closeIcon.vue";
import Importance from "@/components/svgs/importance.vue";
import Impact from "@/components/svgs/impact.vue";
import Effort from "@/components/svgs/effort.vue";
import Cost from "@/components/svgs/cost.vue";
import { computed, onMounted, PropType, Ref, ref, watch } from "vue";
import {
  IFilterSelect,
  IFilterTarget,
  IFilterTargetValue,
  IOriginData,
} from "@/interfaces/common/common";
import { getComponentUiText } from "@/utils/utilities";
import CustomCheckBox from "@/components/common/customCheckBox.vue";
import DatePickInput from "@/components/common/datePickInput.vue";
import CloseBoxIcon from "@/components/svgs/closeBoxIcon.vue";
import {
  FILTER_MODAL_TYPE,
  mainAssessmentFilterDefaul,
} from "@/utils/constants";
import cloneDeep from "lodash/cloneDeep";
import InputFilterModal from "../inputFilterModal.vue";

const props = defineProps({
  isSearch: {
    type: Boolean,
    required: true,
  },
  targets: {
    type: Array as PropType<Array<IFilterTarget>>,
    required: true,
    default: () => [],
  },
  isDate: {
    type: Boolean,
    required: true,
  },
  originalData: {
    type: Object as PropType<IOriginData>,
    required: true,
  },
  showMoreActions: {
    type: Boolean,
    required: false,
    default: false,
  },
  type: {
    type: String,
    required: false,
    default: "",
  },
  outsideFilterModal: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const targetsFilter: Ref<Array<IFilterTarget>> = ref(props.targets);

watch(
  () => props.targets,
  (newValue) => {
    targetsFilter.value = newValue;
  },
  { immediate: true },
);

watch(
  () => props.outsideFilterModal,
  (newValue) => {
    if (newValue) {
      applyFilter();
    }
  },
  { immediate: true },
);
const emits = defineEmits(["update:apply-filter"]);
const filterSelecteds: Ref<IFilterSelect[]> = ref(
  props.originalData?.filterSelected || [],
);
const inputValue = ref(props.originalData?.searchValue);
const searchValue = ref(props.originalData?.searchValue);
const from = ref(props.originalData?.from);
const to = ref(props.originalData?.to);
const selectedDateOpen = ref(false);
const listFilterShow = computed(() => {
  let list = filterSelecteds.value.filter((item) => !item.value.isDefault);
  const listCompliance = list.filter((item) => {
    return item.targetId === "itemCompleteValue-percentage";
  });
  const listScoreIncrease = list.filter((item) => {
    return item.targetId === "score-increase";
  });
  list = list.filter(
    (item) =>
      item.targetId !== "itemCompleteValue-percentage" &&
      item.targetId !== "score-increase",
  );

  if (listCompliance.length > 0) {
    let text = "";

    if (listCompliance.length > 1) {
      text = getComponentUiText(
        "app-component-assessment-display-options-filter-tag-between-1",
        false,
        {
          below:
            listCompliance.find((item) => item.value.id === 0)?.value.percent ??
            "",
          above:
            listCompliance.find((item) => item.value.id === 1)?.value.percent ??
            "",
        },
      );

      list.push({
        targetId: "itemCompleteValue-percentage",
        value: {
          id: [0, 1],
          text,
          isDefault: false,
          isHardText: true,
        },
      });
    } else {
      if (listCompliance[0].value.id === 0) {
        text = getComponentUiText(
          "app-component-assessment-display-options-filter-tag-below-1",
          false,
          {
            below: listCompliance[0].value.percent ?? "",
          },
        );
      } else if (listCompliance[0].value.id === 1) {
        text = getComponentUiText(
          "app-component-assessment-display-options-filter-tag-above-1",
          false,
          {
            above: listCompliance[0].value.percent ?? "",
          },
        );
      }

      list.push({
        targetId: "itemCompleteValue-percentage",
        value: {
          id: listCompliance[0].value.id,
          text,
          isDefault: false,
          isHardText: true,
        },
      });
    }
  }

  if (listScoreIncrease.length > 0) {
    let text = "";

    if (listScoreIncrease.length > 1) {
      text = getComponentUiText(
        "app-component-assessment-display-options-filter-tag-score-between-1",
        false,
        {
          below:
            listScoreIncrease.find((item) => item.value.id === 0)?.value
              .percent ?? "",
          above:
            listScoreIncrease.find((item) => item.value.id === 1)?.value
              .percent ?? "",
        },
      );

      list.push({
        targetId: "score-increase",
        value: {
          id: [0, 1],
          text,
          isDefault: false,
          isHardText: true,
        },
      });
    } else {
      if (listScoreIncrease[0].value.id === 0) {
        text = getComponentUiText(
          "app-component-assessment-display-options-filter-tag-score-below-1",
          false,
          {
            below: listScoreIncrease[0].value.percent ?? "",
          },
        );
      } else if (listScoreIncrease[0].value.id === 1) {
        text = getComponentUiText(
          "app-component-assessment-display-options-filter-tag-score-above-1",
          false,
          {
            above: listScoreIncrease[0].value.percent ?? "",
          },
        );
      }
      list.push({
        targetId: "score-increase",
        value: {
          id: listScoreIncrease[0].value.id,
          text,
          isDefault: false,
          isHardText: true,
        },
      });
    }
  }
  return list;
});

const calNumberTarget = (targetId) => {
  if (filterSelecteds.value.length === 0) return 0;
  return filterSelecteds.value?.filter(
    (item) => item.targetId === targetId && !item.value.isDefault,
  ).length;
};

onMounted(() => {
  if (
    filterSelecteds.value.length === 0 &&
    props.type === FILTER_MODAL_TYPE.mainChecklist
  ) {
    filterSelecteds.value = mainAssessmentFilterDefaul;
  }
});

watch(
  () => filterSelecteds.value,
  (newValue) => {
    if (
      filterSelecteds.value.length === 0 &&
      props.type === FILTER_MODAL_TYPE.mainChecklist
    ) {
      filterSelecteds.value = cloneDeep(mainAssessmentFilterDefaul);
      ``;
    }
  },
);

const onFocusValue = (_, target, val: IFilterTargetValue) => {
  if (
    !filterSelecteds.value.filter(
      (item) => item.targetId === target.targetId && item.value.id === val.id,
    ).length
  ) {
    updateItemFilter(val, target.targetId);
  }
};

const onUpdateInput = (percent, target, val: IFilterTargetValue) => {
  filterSelecteds.value = filterSelecteds.value.map((item) => {
    if (item.targetId === target.targetId && item.value.id === val.id) {
      return {
        ...item,
        value: {
          ...item.value,
          percent,
        },
      };
    }
    return item;
  });
};

const clearAll = () => {
  filterSelecteds.value = [];
  searchValue.value = "";
};

const updateItemFilter = (item, targetId?) => {
  let idx;
  if (!targetId) {
    if (Array.isArray(item.value.id)) {
      idx = item.value.id.map((id) =>
        filterSelecteds.value.findIndex(
          (filter) =>
            filter.targetId === item.targetId && filter.value.id === id,
        ),
      );
    } else {
      idx = filterSelecteds.value.findIndex(
        (filter) =>
          filter.targetId === item.targetId &&
          filter.value.id === item.value.id,
      );
    }
  } else {
    const isRadio =
      props.targets.find((target) => target.targetId === targetId)?.isRadio ||
      false;
    if (isRadio) {
      filterSelecteds.value = filterSelecteds.value.filter(
        (filter) => filter.targetId !== targetId,
      );
      filterSelecteds.value.push({
        targetId: targetId,
        value: item,
      });
      return;
    }
    idx = filterSelecteds.value.findIndex(
      (filter) => filter.targetId === targetId && filter.value.id === item.id,
    );
  }
  if (Array.isArray(idx)) {
    idx
      .sort((a, b) => (a > b ? -1 : 1))
      .forEach((i) => {
        if (i !== -1) {
          filterSelecteds.value.splice(i, 1);
        } else {
          filterSelecteds.value.push({
            targetId: targetId || item.targetId,
            value: item,
          });
        }
      });
    return;
  }
  idx === -1
    ? filterSelecteds.value.push({
        targetId: targetId || item.targetId,
        value: item,
      })
    : filterSelecteds.value.splice(idx, 1);
};

const applyFilter = () => {
  const filterSelectedsFiltered = filterSelecteds.value.filter(
    (item) => item.value.type !== "input" || item.value.percent,
  );
  emits("update:apply-filter", {
    search: searchValue.value,
    filterSelecteds: filterSelectedsFiltered,
    from: from.value,
    to: to.value,
  });
};

watch(
  () => props.showMoreActions,
  (newValue) => {
    if (newValue) {
      filterSelecteds.value = props.originalData?.filterSelected || [];
    }
  },
);
</script>

<style lang="scss" scoped>
.selected-text {
  background: linear-gradient(
    0deg,
    rgba(72, 160, 255, 0.15) 0%,
    rgba(72, 160, 255, 0.15) 100%
  );
  border-radius: 4px;
  display: flex;
  padding: 3px 5px;
  align-items: center;
  gap: 5px;
  justify-content: center;
  width: fit-content;
}
.selected-box {
  flex-flow: row wrap;
}
.border-bottom-box {
  border-bottom: 1px solid #eff0f1;
}
.tw-font-Poppins {
  font-family: Poppins;
}
p {
  margin: 0;
  font-family: Poppins;
}
.clear-text-link {
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}
.rotated {
  transform: rotate(180deg);
}

.box-contain {
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
}
.button-add-domain {
  border-radius: 26.909px !important;
}
.modal-container {
  width: 449px;
  @media (max-width: 767px) {
    max-width: 320px;
    padding: 10px;
  }
}
.create-new-ass-modal-note {
  background: #fff0da;
  color: #fe9a05;
  padding: 4px 8px;
  font-size: 12px;
  text-align: center;
  border-radius: 6px;
  display: flex;
  margin-bottom: 15px;
  font-family: Poppins;
  text-align: left;
}
</style>
